/** 순서를 유지하면서 대량 조회의 동시 실행 수를 제한한다. */
export const mapWithConcurrency = async <T, R>(
    items: T[],
    mapper: (item: T, index: number) => Promise<R>,
    concurrency = 6
): Promise<R[]> => {
    if (!Number.isInteger(concurrency) || concurrency < 1) {
        throw new Error("Concurrency must be a positive integer");
    }
    const results: R[] = new Array(items.length);
    let nextIndex = 0;
    let failed = false;
    const worker = async () => {
        while (!failed && nextIndex < items.length) {
            const index = nextIndex++;
            try {
                results[index] = await mapper(items[index], index);
            } catch (error) {
                failed = true;
                throw error;
            }
        }
    };
    await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, worker));
    return results;
};
